
import React from 'react';
import './IntroSection.css';

function IntroSection() {
  return (
    <div className="intro-section">
      {/* <h2 className="static-subtitle">* A Revolution of Beauty *</h2> */}
      <h2 className="intro-section-title">Devotional Healing</h2>
      <div className="images-container">
      <div className="image-wrapper scroll-card red-overlay">
          <img src="/images/presence.jpg" alt="Devotional 1" loading="lazy" decoding="async"/>
          <div className="overlay-text">Cultivate Presence</div>
        </div>
        <div className="image-wrapper scroll-card cream-overlay">
          <img src="/images/swans.jpeg" alt="Devotional 2" loading="lazy" decoding="async" />
          <div className="overlay-text">Be In Relationship With Life</div>
        </div>
        <div className="image-wrapper scroll-card red-overlay">
          <img src="/images/lilith.jpeg" alt="Devotional 3" loading="lazy" decoding="async" />
          <div className="overlay-text">Feel Your Incarnated Love</div>
        </div>
      </div>
    </div>
  );
}

export default IntroSection;
